export default __webpack_public_path__ + "static/media/sirius.8e50bb23.webp";